import { IDropDown } from "../Interfaces";
import { CaseTypeOptions } from "./CaseTypeOptions";

/**
 * @constant
 * @description - The constants holding the case type dropdown values
 * @type {IDropDown<CaseTypeOptions>[]} - basic drop down option
 */
export const CASE_TYPE_DROP_DOWN: IDropDown<CaseTypeOptions>[] = [
  {
    label: "US.COLLECTION.TRANSACTIONS:CASES_AND_SUBCASES.ALL_CASES",
    value: CaseTypeOptions.ALL,
  },
  {
    label: "US.COLLECTION.TRANSACTIONS:CASES_AND_SUBCASES.SUBCASES",
    value: CaseTypeOptions.SUB_CASE,
  },
  {
    label: "US.COLLECTION.TRANSACTIONS:CASES_AND_SUBCASES.CASES",
    value: CaseTypeOptions.CASE,
  },
];
